<template>
  <div class="fieldYesNo">
    <div class="row" :class="errorClass">
      <div class="col-md-4 col-lg-4 col-xl-3">
        <label class="h6 text-md-right">
          <span v-html="label"></span> <br>
          <small class="text-black-50">{{labelSecondary}}</small>
        </label>
      </div>
      <div class="col-md-8 col-lg-8 col-xl-9">
        <div class="form-check form-check-inline">
          <input :required="isRequired" class="form-check-input" type="radio" name="inlineRadioOptions" id="leadership-yes" v-on:click="selectedOption('Yes')">
          <label class="form-check-label" for="leadership-yes">Yes</label>
        </div>
        <div class="form-check form-check-inline">
          <input :required="isRequired" class="form-check-input" type="radio" name="inlineRadioOptions" id="leadership-no" v-on:click="selectedOption('No')">
          <label class="form-check-label" for="leadership-no">No</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'labelLvl2',
    'labelSecondaryLvl2',
    'isRequired',
    'errorClass'
  ],
  data () {
    return {
      wordsRemaining: 150,
      textContent: '',
      wordCountWarning: '',
      showSecondaryFields: false
    }
  },
  methods: {
    selectedOption: function (option) {
      this.showSecondaryFields = false
      console.log('FieldRadio content ', option)
      this.$emit('addedYesNoContent', {label: this.label, content: option, validated: true})
    }
  }
}
</script>

<style lang="less">
  .word-count-exceeded {
    border-color: red !important;
    background: lightyellow;
  }
  .small-word-count-exceeded {
    color: red !important;
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/components/FieldRadio.vue